import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SplitFactoryProvider } from "@splitsoftware/splitio-react";
import { getSplitConfig } from "./split-factory.helpers";
export const SplitFactoryWithConfig = ({ authorizationKey, children, features, userKey, logImpression, }) => {
    const config = getSplitConfig({
        authorizationKey,
        features,
        userKey,
        logImpression,
    });
    return (_jsx(SplitFactoryProvider, { config: config, children: _jsx(_Fragment, { children: children }) }));
};
//# sourceMappingURL=split-factory.js.map